import React from 'react';
import {useTitle} from 'ahooks';

function DocumentTitle({title}) {
  useTitle(title)
  return null;
}

export default DocumentTitle;
